// Features.jsx
import React from 'react';
import loginImgIn from '../assets/features/features-login-register.png';
import verifyImg from '../assets/features/features-verify.png';
import homepageImg from '../assets/features/features-homepage.png';
import exploreImg from '../assets/features/features-explore.png';
import overviewImg from '../assets/features/features-overview.png';
import submitImg from '../assets/features/features-submit.png';
import aboutImg from '../assets/features/features-about.png';
import interestedImg from '../assets/features/features-interested.png';
import SEO, { seoConfig } from '../component/SEO';
import { website } from '../config/config';
import { Link } from 'react-router-dom';
import PageShapes from '../component/PageShapes';

// 

const features = [
     {
          step: '01',
          title: 'Login / Register',
          desc: 'Create your account and access the platform securely.',
          image: loginImgIn,
          url : '/login',

          steps: [
               {
                    title: 'Enter Details',
                    desc: 'Fill your email and password or use Google login for quick access.'
               },
               {
                    title: 'Create Account',
                    desc: 'New users can register using full name, email, password and confirm password.'
               },
               {
                    title: 'Secure Access',
                    desc: 'Your account is securely authenticated using Firebase.'
               },
               {
                    title: 'Next Step',
                    desc: 'After login, you will be redirected to verification page.'
               }
          ]
     },

     {
          step: '02',
          title: 'Verify Account',
          desc: 'Verify your identity and activate your account.',
          image: verifyImg,
          url: '/verify',

          steps: [
               {
                    title: 'Email Verification',
                    desc: 'Check your email inbox and click the verification link.'
               },
               {
                    title: 'Account Activation',
                    desc: 'Once verified, your account gets full access.'
               },
               {
                    title: 'Security Layer',
                    desc: 'Prevents spam and ensures real users only.'
               }
          ]
     },

     {
          step: '03',
          title: 'Homepage',
          desc: 'Get overview of platform and start your journey.',
          image: homepageImg,
          url: '/',

          steps: [
               {
                    title: 'Platform Overview',
                    desc: 'Understand how HaveIdea works.'
               },
               {
                    title: 'Navigation',
                    desc: 'Access explore, submit, overview and more.'
               }
          ]
     },

     {
          step: '04',
          title: 'Explore Ideas',
          desc: 'Discover problems and ideas shared by others.',
          image: exploreImg,
          url: '/explore',

          steps: [
               {
                    title: 'Browse Ideas',
                    desc: 'See real-world problems posted by users.'
               },
               {
                    title: 'Filter & Search',
                    desc: 'Find ideas based on categories or interests.'
               },
               {
                    title: 'Engage',
                    desc: 'Like, comment and connect with creators.'
               }
          ]
     },

      {
          step: '05',
          title: 'interested Pages',
          desc: 'Discover full',
          image: interestedImg,
          url: '/interested/xQxn88md59qKa8n6uWs0',

          steps: [
               {
                    title: 'Introduction, How It Works Ideas etc' ,
                    desc: 'See real-world problems posted by users.'
               },
               {
                    title: 'Detailed Idea',
                    desc: 'Find ideas based on categories or interests.'
               },
               {
                    title: 'Engage',
                    desc: 'Like, comment and connect with creators.'
               }
          ]
     },

     {
          step: '06',
          title: 'Submit Idea',
          desc: 'Share your idea with the community.',
          image: submitImg,
          url: '/submit',

          steps: [
               {
                    title: 'Write Idea',
                    desc: 'Explain your idea clearly with problem statement.'
               },
               {
                    title: 'Choose Visibility',
                    desc: 'Make it public or keep it private.'
               },
               {
                    title: 'Publish',
                    desc: 'Submit your idea and get feedback.'
               }
          ]
     },

     {
          step: '07',
          title: 'Overview (Private)',
          desc: 'Manage your personal ideas and collaborations.',
          image: overviewImg,
          url: '/overview',

          steps: [
               {
                    title: 'Your Ideas',
                    desc: 'View all your submitted ideas in one place.'
               },
               {
                    title: 'Edit / Delete',
                    desc: 'Update or remove ideas anytime.'
               },
               {
                    title: 'Track Growth',
                    desc: 'Monitor likes, comments and engagement.'
               }
          ]
     },

     {
          step: '08',
          title: 'About Platform',
          desc: 'Learn about mission and vision of HaveIdea.',
          image: aboutImg,
          url: '/about',

          steps: [
               {
                    title: 'Vision',
                    desc: 'Understand the goal of building ideas into products.'
               },
               {
                    title: 'Community',
                    desc: 'Connect with builders and innovators.'
               }
          ]
     }
];

const Features = () => {
     return (
          <>
          <PageShapes />
          <SEO {...seoConfig.features} />

          <main className="features-page">

               <section className="features-hero">
                    <div className="container-features">
                         <h1>Build Better Ideas, Faster</h1>
                         <p>From idea capture to validation and collaboration — everything in one place.</p>
                    </div>
               </section>

               <section className="features-list">
                    <div className="container-features">

                         {features.map((f, i) => (
                              <div key={i} className={`feature-row ${i % 2 !== 0 ? 'reverse' : ''}`}>

                                   <div className="feature-image">
                                        <img src={f.image} alt={f.title} />
                                   </div>

                                   <div className="feature-content">
                                        <span className="step">{f.step}</span>
                                        <h2>{f.title}</h2>
                                        <p>{f.desc}</p>

                                        <Link to={f?.url} target='_blank'> {website}{f?.url} </Link>

                                        <div className="feature-steps">
                                             {f.steps.map((s, idx) => (
                                                  <div className="step-card" key={idx}>
                                                       <p className='subjeadg'>{s.title}</p>
                                                       <p>{s.desc}</p>
                                                  </div>
                                             ))}
                                        </div>
                                   </div>

                              </div>
                         ))}

                    </div>
               </section>

               <section className="features-cta">
                    <div className="container">
                         <h2>Start turning ideas into reality</h2>
                         <p>Join builders and launch your next big thing.</p>
                         <a href="/submit" className="cta-btn">Get Started</a>
                    </div>
               </section>

          </main>
          </>

     );
};

export default Features;